module.exports = __webpack_public_path__ + "img/pg.e5b23454.png";